

class CoinsAnimations
{
    constructor()
    {
        this.SMALL_WIN = 1;
        this.NORMAL_WIN = 2;
        this.BIG_WIN = 3;
        this.BOMB_WIN = 4;

        this.coinData =
        {
            1: {
                coinsMin: 10,
                coinsMax: 15,
                minSize: 2,
                maxSize: 3,
                spawnDuration: 0.4,
                type: "ring"
            },
            2: {
                coinsMin: 20,
                coinsMax: 25,
                minSize: 2,
                maxSize: 3,
                spawnDuration: 0.4,
                type: "doubleRing"
            },
            3: {
                coinsMin: 35,
                coinsMax: 35,
                minSize: 1.75,
                maxSize: 1.75,
                spawnDuration: 0.4,
                type: "star",
                positions: [

                ]
            },
            4: {
                coinsMin: 60,
                coinsMax: 60,
                minSize: 2,
                maxSize: 2,
                spawnDuration: 0.4,
                type: "bomb"
            }
        }
    }
}

export default (new CoinsAnimations);